import * as React from "react";

export type App = "marketplace" | "connect-api" | "partners";

type AppContextType = {
  currentApp: App | null;
};

export const AppContext = React.createContext<AppContextType>({
  currentApp: "marketplace",
});
